/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc
 */

export const getMcpServerByIdRpc = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc',
  rpcName: 'getMcpServerById',
  auth: 'app',
  fingerprint: '35etkYBEAT9FZ8eGoUR1q8kRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMcpServersRpc = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc',
  rpcName: 'getMcpServers',
  auth: 'app',
  fingerprint: 'OIROYkaHPXGdybQ8bLjJC8kRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMcpServersByAuthenticatorIdRpc = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc',
  rpcName: 'getMcpServersByAuthenticatorId',
  auth: 'app',
  fingerprint: 'Ctdnmd9oG8KdybQ8bLjJC8kRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMcpServerLogosRpc = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc',
  rpcName: 'getMcpServerLogos',
  auth: 'app',
  fingerprint: 'SfCf4RDFamUdW_jR30YWAskRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMcpServersAvailableToPortalRpc = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc',
  rpcName: 'getMcpServersAvailableToPortal',
  auth: 'app',
  fingerprint: '9NQZKNIFY6edybQ8bLjJC8kRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMcpServersByAppIdRpc = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc',
  rpcName: 'getMcpServersByAppId',
  auth: 'app',
  fingerprint: 'v7m0kZM0NsadybQ8bLjJC8kRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMcpServersAvailableToPortalPaginatedRpc = {
  serviceName: 'com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc',
  rpcName: 'getMcpServersAvailableToPortalPaginated',
  auth: 'app',
  fingerprint: 'JpnG1PKyJEcWRZ8SSxTflckRpt9Ad8BO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};